/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderLabelResponse
 */
export interface OrderLabelResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderLabelResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLabelResponse
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLabelResponse
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLabelResponse
     */
    color: string;
}

/**
 * Check if a given object implements the OrderLabelResponse interface.
 */
export function instanceOfOrderLabelResponse(value: object): value is OrderLabelResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('orderId' in value) || value['orderId'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('color' in value) || value['color'] === undefined) return false;
    return true;
}

export function OrderLabelResponseFromJSON(json: any): OrderLabelResponse {
    return OrderLabelResponseFromJSONTyped(json, false);
}

export function OrderLabelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderLabelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'orderId': json['orderId'],
        'text': json['text'],
        'color': json['color'],
    };
}

export function OrderLabelResponseToJSON(json: any): OrderLabelResponse {
    return OrderLabelResponseToJSONTyped(json, false);
}

export function OrderLabelResponseToJSONTyped(value?: OrderLabelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderId': value['orderId'],
        'text': value['text'],
        'color': value['color'],
    };
}

